import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { OosConfirmationContent } from "../components/OosConfirmationContent";
import { useFetchJobTasks, useFetchTask, useFetchJob } from "@labeling-tools/api/lebron/react-query-hooks";
import { LoadingOverlay } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { HEADER_HEIGHT, RESULTS_SIDEBAR_WIDTH } from "@/config/data";
import { AdminToolbar } from "@/components/AdminToolbar";
import { ConfirmationResultsSidebar } from "@/components/ConfirmationResultsSidebar";
import { isEmpty } from "lodash";

export const AdminOosConfirmation = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");

  const { data: job } = useFetchJob(jobId || "");
  const { data: jobTasks, isLoading: jobTasksLoading } = useFetchJobTasks(
    jobId || "",
  );
  const { data: task, isLoading: taskLoading } = useFetchTask(
    jobId || "",
    taskId || jobTasks?.tasks[0]?.id,
  );

  useEffect(() => {
    if (task && !taskId) {
      navigate(
        `/jobs/${jobId}/admin-confirmation?taskId=${jobTasks?.tasks[0]?.id}`,
        { replace: true },
      );
    }
  }, [task]);

  if (jobTasksLoading || taskLoading) {
    return <LoadingOverlay />;
  }
  const hasResults = !!task?.result && !isEmpty(task.result);
  return (
    <div style={{ paddingTop: HEADER_HEIGHT }}>
      {/* admin toolbar */}
      {jobTasks && task && (
        <AdminToolbar jobTasks={jobTasks} activeTask={task} />
      )}

      {/* main content */}
      <div style={{ paddingRight: hasResults ? RESULTS_SIDEBAR_WIDTH : 0 }}>
        <OosConfirmationContent mode="admin" />
      </div>

      {/* results sidebar */}
      {hasResults && <ConfirmationResultsSidebar task={task} testing={job?.testing} />}
    </div>
  );
};
